var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partner-task-detail"},[_c('OrderDetail',{attrs:{"CanChecked":_vm.canChecked,"OrderId":_vm.orderId,"DispatchId":_vm.dispatchId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }